import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { badgeColorCode, BadgeOptions, eventEmitter } from './badge.interface';
import { UtilityService } from 'app/core/services/utility_functions/utility_functions.service';

@Component({
    selector: 'badge',
    templateUrl: './badge.component.html',
    styleUrls: ['./badge.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class BadgeComponent implements OnInit, OnChanges {
    @Input() options: BadgeOptions = null;
    @Output() eventEmitter = new EventEmitter<eventEmitter>();
    customClass: string;
    colorCode: string = '';
    enableClick: boolean = false;

    constructor(private _utilityService: UtilityService) {}

    ngOnInit(): void {
        if (typeof this.options === 'string') {
            this.options = JSON.parse(this.options);
        }
        this.getColorCode();
        this.customClass = this.applyClass();
    }

    getColorCode(): void {
        if(this.options?.color && this.options?.color.length !== 0){
            this.colorCode = this.options.color;
        }else if(this.options?.type){
            this.colorCode = badgeColorCode[this.options.type];
        }else {
            this.colorCode = badgeColorCode['PRIMARY'];
        }
        // this.colorCode = this.options.color ?? (badgeColorCode[this.options.type] ?? badgeColorCode['PRIMARY']);
    }

    getBadgeStyles(): any {
        return {
            'color': this.colorCode,
            'background-color': this.options.backgroundColor ?? this._utilityService.convertHexToRgba(this.colorCode),
            'vertical-align' : 'text-bottom',
            'border-color': this.options?.displayType === 'chip' ? this._utilityService.convertHexToRgba(this.colorCode) : this.colorCode
        };
    }

    applyClass(): string {
        let classes = '';
        switch (this.options?.displayType) {
            case 'tags':
                classes = 'tag-badge';
                break;
            case 'roundedTags':
                classes = 'tag-badge-rounded';
                break;
            case 'summaryCount':
                classes = 'px-2 py-1 text-sm rounded-full';
                break;
            case 'listingCount':
                classes = 'px-2 py-1 text-md font-medium rounded-full w-full justify-center min-h-7 truncate';
                break;
            case 'chip':
                classes = 'rounded-full font-medium rounded-chip';
                break;
            default:
                classes = 'py-0.5 px-2.5 text-base font-medium rounded border';
                break;
        };
        return `${classes} ${this.options?.extraClass ? this.options.extraClass : ''} truncate`;
    }

    onClick(): void{
        this.eventEmitter.emit({
            isClicked: true
        });
    }

    ngOnChanges(changes: SimpleChanges): void{
        if('options' in changes){
            this.options = changes.options.currentValue;
            this.getColorCode();
            if(this.options?.enableClick){
                this.enableClick = true;
            }
        }
    }
}
